import { useBlocker } from '@tanstack/react-router';
import { useBoundStore } from '@Store/useBoundStore';
import { NonUSSocurePageLayout } from '@Pages/happyFlowPages/NonUsSocure/NonUSSocurePage';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { useUboDocVLogic } from './hooks/useUboDocVLogic';

export const UboDocVPage = () => {
  useBlocker({
    shouldBlockFn: ({ next }) => {
      const allowedRoutes: string[] = [
        routesModel[RoutesMap.INVITE_TEAM_MEMBER_FINISHED].path,
        routesModel[RoutesMap.VERIFICATION_FAILED].path,
        routesModel[RoutesMap.UNDER_REVIEW].path,
      ];
      return !allowedRoutes.includes(next.routeId);
    },
  });

  const docVData = useBoundStore((state) => state.docVData);
  const logic = useUboDocVLogic();

  const socureData = {
    qrCode: docVData?.qrCode,
    url: docVData?.url,
  };

  return <NonUSSocurePageLayout socureData={socureData} logic={logic} skipDefaultPolling={true} />;
};
